module.exports = __webpack_public_path__ + "media/images/covid/icons/mask-fcbbeb06229d02ae398ece45f933f3d1.png";